var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModuleType = function SvgModuleType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#moduleType_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.38.857H4.953a3.43 3.43 0 0 0-3.429 3.429v15.429a3.43 3.43 0 0 0 3.429 3.428h15.429a3.43 3.43 0 0 0 3.428-3.428V4.286A3.43 3.43 0 0 0 20.381.857M12.667.857v22.286M1.523 12H23.81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "moduleType_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h24v24h-24z"
  })))));
};
export default SvgModuleType;